(function (window, document, $, undefined) {
  "use strict";

  window.console = window.console || {
	info: function (stuff) {}
  };

  // If there's no jQuery, fancyBox can't work
  // =========================================

  if (!$) {
	return;
  }

  // Check if fancyBox is already initialized
  // ========================================

  if ($.fn.fancybox) {
	console.info("fancyBox already initialized");

	return;
  }

  // Private default settings
  // ========================

  var defaults = {
	// Close existing modals
	// Set this to false if you do not need to stack multiple instances
	closeExisting: false,

	// Enable infinite gallery navigation
	loop: false,

	// Horizontal space between slides
	gutter: 50,

	// Enable keyboard navigation
	keyboard: true,

	// Should allow caption to overlap the content
	preventCaptionOverlap: true,

	// Should display navigation arrows at the screen edges
	arrows: true,

	// Should display counter at the top left corner
	infobar: true,

	// Should display close button (using `btnTpl.smallBtn` template) over the content
	// Can be true, false, "auto"
	// If "auto" - will be automatically enabled for "html", "inline" or "ajax" items
	smallBtn: "auto",

	// Should display toolbar (buttons at the top)
	// Can be true, false, "auto"
	// If "auto" - will be automatically hidden if "smallBtn" is enabled
	toolbar: "auto",

	// What buttons should appear in the top right corner.
	// Buttons will be created using templates from `btnTpl` option
	// and they will be placed into toolbar (class="fancybox-toolbar"` element)
	buttons: [
	  "zoom",
	  //"share",
	  "slideShow",
	  //"fullScreen",
	  //"download",
	  "thumbs",
	  "close"
	],

	// Detect "idle" time in seconds
	idleTime: 3,

	// Disable right-click and use simple image protection for images
	protect: false,

	// Shortcut to make content "modal" - disable keyboard navigtion, hide buttons, etc
	modal: false,

	image: {
	  // Wait for images to load before displaying
	  //   true  - wait for image to load and then display;
	  //   false - display thumbnail and load the full-sized image over top,
	  //           requires predefined image dimensions (`data-width` and `data-height` attributes)
	  preload: false
	},

	ajax: {
	  // Object containing settings for ajax request
	  settings: {
		// This helps to indicate that request comes from the modal
		// Feel free to change naming
		data: {
		  fancybox: true
		}
	  }
	},

	iframe: {
	  // Iframe template
	  tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',

	  // Preload iframe before displaying it
	  // This allows to calculate iframe content width and height
	  // (note: Due to "Same Origin Policy", you can't get cross domain data).
	  preload: true,

	  // Custom CSS styling for iframe wrapping element
	  // You can use this to set custom iframe dimensions
	  css: {},

	  // Iframe tag attributes
	  attr: {
		scrolling: "auto"
	  }
	},

	// For HTML5 video only
	video: {
	  tpl: '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}">' +
		'<source src="{{src}}" type="{{format}}" />' +
		'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
		"</video>",
	  format: "", // custom video format
	  autoStart: true
	},

	// Default content type if cannot be detected automatically
	defaultType: "image",

	// Open/close animation type
	// Possible values:
	//   false            - disable
	//   "zoom"           - zoom images from/to thumbnail
	//   "fade"
	//   "zoom-in-out"
	//
	animationEffect: "zoom",

	// Duration in ms for open/close animation
	animationDuration: 366,

	// Should image change opacity while zooming
	// If opacity is "auto", then opacity will be changed if image and thumbnail have different aspect ratios
	zoomOpacity: "auto",

	// Transition effect between slides
	//
	// Possible values:
	//   false            - disable
	//   "fade'
	//   "slide'
	//   "circular'
	//   "tube'
	//   "zoom-in-out'
	//   "rotate'
	//
	transitionEffect: "fade",

	// Duration in ms for transition animation
	transitionDuration: 366,

	// Custom CSS class for slide element
	slideClass: "",

	// Custom CSS class for layout
	baseClass: "",

	// Base template for layout
	baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1">' +
	  '<div class="fancybox-bg"></div>' +
	  '<div class="fancybox-inner">' +
	  '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
	  '<div class="fancybox-toolbar">{{buttons}}</div>' +
	  '<div class="fancybox-navigation">{{arrows}}</div>' +
	  '<div class="fancybox-stage"></div>' +
	  '<div class="fancybox-caption"><div class="fancybox-caption__body"></div></div>' +
	  "</div>" +
	  "</div>",

	// Loading indicator template
	spinnerTpl: '<div class="fancybox-loading"></div>',

	// Error message template
	errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',

	btnTpl: {
	  download: '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;">' +
		'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg>' +
		"</a>",

	  zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}">' +
		'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg>' +
		"</button>",

	  close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
		'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg>' +
		"</button>",

	  // Arrows
	  arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
		'<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div>' +
		"</button>",

	  arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
		'<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div>' +
		"</button>",

	  // This small close button will be appended to your html/inline/ajax content by default,
	  // if "smallBtn" option is not set to false
	  smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
		'<svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg>' +
		"</button>"
	},

	// Container is injected into this element
	parentEl: "body",

	// Hide browser vertical scrollbars; use at your own risk
	hideScrollbar: true,

	// Focus handling
	// ==============

	// Try to focus on the first focusable element after opening
	autoFocus: true,

	// Put focus back to active element after closing
	backFocus: true,

	// Do not let user to focus on element outside modal content
	trapFocus: true,

	// Module specific options
	// =======================

	fullScreen: {
	  autoStart: false
	},

	// Set `touch: false` to disable panning/swiping
	touch: {
	  vertical: true, // Allow to drag content vertically
	  momentum: true // Continue movement after releasing mouse/touch when panning
	},

	// Hash value when initializing manually,
	// set `false` to disable hash change
	hash: null,

	// Customize or add new media types
	// Example:
	/*
	  media : {
		youtube : {
		  params : {
			autoplay : 0
		  }
		}
	  }
	*/
	media: {},

	slideShow: {
	  autoStart: false,
	  speed: 3000
	},

	thumbs: {
	  autoStart: false, // Display thumbnails on opening
	  hideOnClose: true, // Hide thumbnail grid when closing animation starts
	  parentEl: ".fancybox-container", // Container is injected into this element
	  axis: "y" // Vertical (y) or horizontal (x) scrolling
	},

	// Use mousewheel to navigate gallery
	// If 'auto' - enabled for images only
	wheel: "auto",

	// Callbacks
	//==========

	// See Documentation/API/Events for more information
	// Example:
	/*
	  afterShow: function( instance, current ) {
		console.info( 'Clicked element:' );
		console.info( current.opts.$orig );
	  }
	*/

	onInit: $.noop, // When instance has been initialized

	beforeLoad: $.noop, // Before the content of a slide is being loaded
	afterLoad: $.noop, // When the content of a slide is done loading

	beforeShow: $.noop, // Before open animation starts
	afterShow: $.noop, // When content is done loading and animating

	beforeClose: $.noop, // Before the instance attempts to close. Return false to cancel the close.
	afterClose: $.noop, // After instance has been closed

	onActivate: $.noop, // When instance is brought to front
	onDeactivate: $.noop, // When other instance has been activated

	// Interaction
	// ===========

	// Use options below to customize taken action when user clicks or double clicks on the fancyBox area,
	// each option can be string or method that returns value.
	//
	// Possible values:
	//   "close"           - close instance
	//   "next"            - move to next gallery item
	//   "nextOrClose"     - move to next gallery item or close if gallery has only one item
	//   "toggleControls"  - show/hide controls
	//   "zoom"            - zoom image (if loaded)
	//   false             - do nothing

	// Clicked on the content
	clickContent: function (current, event) {
	  return current.type === "image" ? "zoom" : false;
	},

	// Clicked on the slide
	clickSlide: "close",

	// Clicked on the background (backdrop) element;
	// if you have not changed the layout, then most likely you need to use `clickSlide` option
	clickOutside: "close",

	// Same as previous two, but for double click
	dblclickContent: false,
	dblclickSlide: false,
	dblclickOutside: false,

	// Custom options when mobile device is detected
	// =============================================

	mobile: {
	  preventCaptionOverlap: false,
	  idleTime: false,
	  clickContent: function (current, event) {
		return current.type === "image" ? "toggleControls" : false;
	  },
	  clickSlide: function (current, event) {
		return current.type === "image" ? "toggleControls" : "close";
	  },
	  dblclickContent: function (current, event) {
		return current.type === "image" ? "zoom" : false;
	  },
	  dblclickSlide: function (current, event) {
		return current.type === "image" ? "zoom" : false;
	  }
	},

	// Internationalization
	// ====================

	lang: "en",
	i18n: {
	  en: {
		CLOSE: "Close",
		NEXT: "Next",
		PREV: "Previous",
		ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
		PLAY_START: "Start slideshow",
		PLAY_STOP: "Pause slideshow",
		FULL_SCREEN: "Full screen",
		THUMBS: "Thumbnails",
		DOWNLOAD: "Download",
		SHARE: "Share",
		ZOOM: "Zoom"
	  },
	  de: {
		CLOSE: "Schlie&szlig;en",
		NEXT: "Weiter",
		PREV: "Zur&uuml;ck",
		ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
		PLAY_START: "Diaschau starten",
		PLAY_STOP: "Diaschau beenden",
		FULL_SCREEN: "Vollbild",
		THUMBS: "Vorschaubilder",
		DOWNLOAD: "Herunterladen",
		SHARE: "Teilen",
		ZOOM: "Vergr&ouml;&szlig;ern"
	  }
	}
  };

  // Few useful variables and methods
  // ================================

  var $W = $(window);
  var $D = $(document);

  var called = 0;

  // Check if an object is a jQuery object and not a native JavaScript object
  // ========================================================================
  var isQuery = function (obj) {
	return obj && obj.hasOwnProperty && obj instanceof $;
  };

  // Handle multiple browsers for "requestAnimationFrame" and "cancelAnimationFrame"
  // ===============================================================================
  var requestAFrame = (function () {
	return (
	  window.requestAnimationFrame ||
	  window.webkitRequestAnimationFrame ||
	  window.mozRequestAnimationFrame ||
	  window.oRequestAnimationFrame ||
	  // if all else fails, use setTimeout
	  function (callback) {
		return window.setTimeout(callback, 1000 / 60);
	  }
	);
  })();

  var cancelAFrame = (function () {
	return (
	  window.cancelAnimationFrame ||
	  window.webkitCancelAnimationFrame ||
	  window.mozCancelAnimationFrame ||
	  window.oCancelAnimationFrame ||
	  function (id) {
		window.clearTimeout(id);
	  }
	);
  })();

  // Detect the supported transition-end event property name
  // =======================================================
  var transitionEnd = (function () {
	var el = document.createElement("fakeelement"),
	  t;

	var transitions = {
	  transition: "transitionend",
	  OTransition: "oTransitionEnd",
	  MozTransition: "transitionend",
	  WebkitTransition: "webkitTransitionEnd"
	};

	for (t in transitions) {
	  if (el.style[t] !== undefined) {
		return transitions[t];
	  }
	}

	return "transitionend";
  })();

  // Force redraw on an element.
  // This helps in cases where the browser doesn't redraw an updated element properly
  // ================================================================================
  var forceRedraw = function ($el) {
	return $el && $el.length && $el[0].offsetHeight;
  };

  // Exclude array (`buttons`) options from deep merging
  // ===================================================
  var mergeOpts = function (opts1, opts2) {
	var rez = $.extend(true, {}, opts1, opts2);

	$.each(opts2, function (key, value) {
	  if ($.isArray(value)) {
		rez[key] = value;
	  }
	});

	return rez;
  };

  // How much of an element is visible in viewport
  // =============================================

  var inViewport = function (elem) {
	var elemCenter, rez;

	if (!elem || elem.ownerDocument !== document) {
	  return false;
	}

	$(".fancybox-container").css("pointer-events", "none");

	elemCenter = {
	  x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
	  y: elem.getBoundingClientRect().top + elem.offsetHeight / 2
	};

	rez = document.elementFromPoint(elemCenter.x, elemCenter.y) === elem;

	$(".fancybox-container").css("pointer-events", "");

	return rez;
  };

  // Class definition
  // ================

  var FancyBox = function (content, opts, index) {
	var self = this;

	self.opts = mergeOpts({
	  index: index
	}, $.fancybox.defaults);

	if ($.isPlainObject(opts)) {
	  self.opts = mergeOpts(self.opts, opts);
	}

	if ($.fancybox.isMobile) {
	  self.opts = mergeOpts(self.opts, self.opts.mobile);
	}

	self.id = self.opts.id || ++called;

	self.currIndex = parseInt(self.opts.index, 10) || 0;
	self.prevIndex = null;

	self.prevPos = null;
	self.currPos = 0;

	self.firstRun = true;

	// All group items
	self.group = [];

	// Existing slides (for current, next and previous gallery items)
	self.slides = {};

	// Create group elements
	self.addContent(content);

	if (!self.group.length) {
	  return;
	}

	self.init();
  };

  $.extend(FancyBox.prototype, {
	// Create DOM structure
	// ====================

	init: function () {
	  var self = this,
		firstItem = self.group[self.currIndex],
		firstItemOpts = firstItem.opts,
		$container,
		buttonStr;

	  if (firstItemOpts.closeExisting) {
		$.fancybox.close(true);
	  }

	  // Hide scrollbars
	  // ===============

	  $("body").addClass("fancybox-active");

	  if (
		!$.fancybox.getInstance() &&
		firstItemOpts.hideScrollbar !== false &&
		!$.fancybox.isMobile &&
		document.body.scrollHeight > window.innerHeight
	  ) {
		$("head").append(
		  '<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' +
		  (window.innerWidth - document.documentElement.clientWidth) +
		  "px;}</style>"
		);

		$("body").addClass("compensate-for-scrollbar");
	  }

	  // Build html markup and set references
	  // ====================================

	  // Build html code for buttons and insert into main template
	  buttonStr = "";

	  $.each(firstItemOpts.buttons, function (index, value) {
		buttonStr += firstItemOpts.btnTpl[value] || "";
	  });

	  // Create markup from base template, it will be initially hidden to
	  // avoid unnecessary work like painting while initializing is not complete
	  $container = $(
		  self.translate(
			self,
			firstItemOpts.baseTpl
			.replace("{{buttons}}", buttonStr)
			.replace("{{arrows}}", firstItemOpts.btnTpl.arrowLeft + firstItemOpts.btnTpl.arrowRight)
		  )
		)
		.attr("id", "fancybox-container-" + self.id)
		.addClass(firstItemOpts.baseClass)
		.data("FancyBox", self)
		.appendTo(firstItemOpts.parentEl);

	  // Create object holding references to jQuery wrapped nodes
	  self.$refs = {
		container: $container
	  };

	  ["bg", "inner", "infobar", "toolbar", "stage", "caption", "navigation"].forEach(function (item) {
		self.$refs[item] = $container.find(".fancybox-" + item);
	  });

	  self.trigger("onInit");

	  // Enable events, deactive previous instances
	  self.activate();

	  // Build slides, load and reveal content
	  self.jumpTo(self.currIndex);
	},

	// Simple i18n support - replaces object keys found in template
	// with corresponding values
	// ============================================================

	translate: function (obj, str) {
	  var arr = obj.opts.i18n[obj.opts.lang] || obj.opts.i18n.en;

	  return str.replace(/\{\{(\w+)\}\}/g, function (match, n) {
		return arr[n] === undefined ? match : arr[n];
	  });
	},

	// Populate current group with fresh content
	// Check if each object has valid type and content
	// ===============================================

	addContent: function (content) {
	  var self = this,
		items = $.makeArray(content),
		thumbs;

	  $.each(items, function (i, item) {
		var obj = {},
		  opts = {},
		  $item,
		  type,
		  found,
		  src,
		  srcParts;

		// Step 1 - Make sure we have an object
		// ====================================

		if ($.isPlainObject(item)) {
		  // We probably have manual usage here, something like
		  // $.fancybox.open( [ { src : "image.jpg", type : "image" } ] )

		  obj = item;
		  opts = item.opts || item;
		} else if ($.type(item) === "object" && $(item).length) {
		  // Here we probably have jQuery collection returned by some selector
		  $item = $(item);

		  // Support attributes like `data-options='{"touch" : false}'` and `data-touch='false'`
		  opts = $item.data() || {};
		  opts = $.extend(true, {}, opts, opts.options);

		  // Here we store clicked element
		  opts.$orig = $item;

		  obj.src = self.opts.src || opts.src || $item.attr("href");

		  // Assume that simple syntax is used, for example:
		  //   `$.fancybox.open( $("#test"), {} );`
		  if (!obj.type && !obj.src) {
			obj.type = "inline";
			obj.src = item;
		  }
		} else {
		  // Assume we have a simple html code, for example:
		  //   $.fancybox.open( '<div><h1>Hi!</h1></div>' );
		  obj = {
			type: "html",
			src: item + ""
		  };
		}

		// Each gallery object has full collection of options
		obj.opts = $.extend(true, {}, self.opts, opts);

		// Do not merge buttons array
		if ($.isArray(opts.buttons)) {
		  obj.opts.buttons = opts.buttons;
		}

		if ($.fancybox.isMobile && obj.opts.mobile) {
		  obj.opts = mergeOpts(obj.opts, obj.opts.mobile);
		}

		// Step 2 - Make sure we have content type, if not - try to guess
		// ==============================================================

		type = obj.type || obj.opts.type;
		src = obj.src || "";

		if (!type && src) {
		  if ((found = src.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))) {
			type = "video";

			if (!obj.opts.video.format) {
			  obj.opts.video.format = "video/" + (found[1] === "ogv" ? "ogg" : found[1]);
			}
		  } else if (src.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i)) {
			type = "image";
		  } else if (src.match(/\.(pdf)((\?|#).*)?$/i)) {
			type = "iframe";
			obj = $.extend(true, obj, {
			  contentType: "pdf",
			  opts: {
				iframe: {
				  preload: false
				}
			  }
			});
		  } else if (src.charAt(0) === "#") {
			type = "inline";
		  }
		}

		if (type) {
		  obj.type = type;
		} else {
		  self.trigger("objectNeedsType", obj);
		}

		if (!obj.contentType) {
		  obj.contentType = $.inArray(obj.type, ["html", "inline", "ajax"]) > -1 ? "html" : obj.type;
		}

		// Step 3 - Some adjustments
		// =========================

		obj.index = self.group.length;

		if (obj.opts.smallBtn == "auto") {
		  obj.opts.smallBtn = $.inArray(obj.type, ["html", "inline", "ajax"]) > -1;
		}

		if (obj.opts.toolbar === "auto") {
		  obj.opts.toolbar = !obj.opts.smallBtn;
		}

		// Find thumbnail image, check if exists and if is in the viewport
		obj.$thumb = obj.opts.$thumb || null;

		if (obj.opts.$trigger && obj.index === self.opts.index) {
		  obj.$thumb = obj.opts.$trigger.find("img:first");

		  if (obj.$thumb.length) {
			obj.opts.$orig = obj.opts.$trigger;
		  }
		}

		if (!(obj.$thumb && obj.$thumb.length) && obj.opts.$orig) {
		  obj.$thumb = obj.opts.$orig.find("img:first");
		}

		if (obj.$thumb && !obj.$thumb.length) {
		  obj.$thumb = null;
		}

		obj.thumb = obj.opts.thumb || (obj.$thumb ? obj.$thumb[0].src : null);

		// "caption" is a "special" option, it can be used to customize caption per gallery item
		if ($.type(obj.opts.caption) === "function") {
		  obj.opts.caption = obj.opts.caption.apply(item, [self, obj]);
		}

		if ($.type(self.opts.caption) === "function") {
		  obj.opts.caption = self.opts.caption.apply(item, [self, obj]);
		}

		// Make sure we have caption as a string or jQuery object
		if (!(obj.opts.caption instanceof $)) {
		  obj.opts.caption = obj.opts.caption === undefined ? "" : obj.opts.caption + "";
		}

		// Check if url contains "filter" used to filter the content
		// Example: "ajax.html #something"
		if (obj.type === "ajax") {
		  srcParts = src.split(/\s+/, 2);

		  if (srcParts.length > 1) {
			obj.src = srcParts.shift();

			obj.opts.filter = srcParts.shift();
		  }
		}

		// Hide all buttons and disable interactivity for modal items
		if (obj.opts.modal) {
		  obj.opts = $.extend(true, obj.opts, {
			trapFocus: true,
			// Remove buttons
			infobar: 0,
			toolbar: 0,

			smallBtn: 0,

			// Disable keyboard navigation
			keyboard: 0,

			// Disable some modules
			slideShow: 0,
			fullScreen: 0,
			thumbs: 0,
			touch: 0,

			// Disable click event handlers
			clickContent: false,
			clickSlide: false,
			clickOutside: false,
			dblclickContent: false,
			dblclickSlide: false,
			dblclickOutside: false
		  });
		}

		// Step 4 - Add processed object to group
		// ======================================

		self.group.push(obj);
	  });

	  // Update controls if gallery is already opened
	  if (Object.keys(self.slides).length) {
		self.updateControls();

		// Update thumbnails, if needed
		thumbs = self.Thumbs;

		if (thumbs && thumbs.isActive) {
		  thumbs.create();

		  thumbs.focus();
		}
	  }
	},

	// Attach an event handler functions for:
	//   - navigation buttons
	//   - browser scrolling, resizing;
	//   - focusing
	//   - keyboard
	//   - detecting inactivity
	// ======================================

	addEvents: function () {
	  var self = this;

	  self.removeEvents();

	  // Make navigation elements clickable
	  // ==================================

	  self.$refs.container
		.on("click.fb-close", "[data-fancybox-close]", function (e) {
		  e.stopPropagation();
		  e.preventDefault();

		  self.close(e);
		})
		.on("touchstart.fb-prev click.fb-prev", "[data-fancybox-prev]", function (e) {
		  e.stopPropagation();
		  e.preventDefault();

		  self.previous();
		})
		.on("touchstart.fb-next click.fb-next", "[data-fancybox-next]", function (e) {
		  e.stopPropagation();
		  e.preventDefault();

		  self.next();
		})
		.on("click.fb", "[data-fancybox-zoom]", function (e) {
		  // Click handler for zoom button
		  self[self.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
		});

	  // Handle page scrolling and browser resizing
	  // ==========================================

	  $W.on("orientationchange.fb resize.fb", function (e) {
		if (e && e.originalEvent && e.originalEvent.type === "resize") {
		  if (self.requestId) {
			cancelAFrame(self.requestId);
		  }

		  self.requestId = requestAFrame(function () {
			self.update(e);
		  });
		} else {
		  if (self.current && self.current.type === "iframe") {
			self.$refs.stage.hide();
		  }

		  setTimeout(
			function () {
			  self.$refs.stage.show();

			  self.update(e);
			},
			$.fancybox.isMobile ? 600 : 250
		  );
		}
	  });

	  $D.on("keydown.fb", function (e) {
		var instance = $.fancybox ? $.fancybox.getInstance() : null,
		  current = instance.current,
		  keycode = e.keyCode || e.which;

		// Trap keyboard focus inside of the modal
		// =======================================

		if (keycode == 9) {
		  if (current.opts.trapFocus) {
			self.focus(e);
		  }

		  return;
		}

		// Enable keyboard navigation
		// ==========================

		if (!current.opts.keyboard || e.ctrlKey || e.altKey || e.shiftKey || $(e.target).is("input,textarea,video,audio,select")) {
		  return;
		}

		// Backspace and Esc keys
		if (keycode === 8 || keycode === 27) {
		  e.preventDefault();

		  self.close(e);

		  return;
		}

		// Left arrow and Up arrow
		if (keycode === 37 || keycode === 38) {
		  e.preventDefault();

		  self.previous();

		  return;
		}

		// Righ arrow and Down arrow
		if (keycode === 39 || keycode === 40) {
		  e.preventDefault();

		  self.next();

		  return;
		}

		self.trigger("afterKeydown", e, keycode);
	  });

	  // Hide controls after some inactivity period
	  if (self.group[self.currIndex].opts.idleTime) {
		self.idleSecondsCounter = 0;

		$D.on(
		  "mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle",
		  function (e) {
			self.idleSecondsCounter = 0;

			if (self.isIdle) {
			  self.showControls();
			}

			self.isIdle = false;
		  }
		);

		self.idleInterval = window.setInterval(function () {
		  self.idleSecondsCounter++;

		  if (self.idleSecondsCounter >= self.group[self.currIndex].opts.idleTime && !self.isDragging) {
			self.isIdle = true;
			self.idleSecondsCounter = 0;

			self.hideControls();
		  }
		}, 1000);
	  }
	},

	// Remove events added by the core
	// ===============================

	removeEvents: function () {
	  var self = this;

	  $W.off("orientationchange.fb resize.fb");
	  $D.off("keydown.fb .fb-idle");

	  this.$refs.container.off(".fb-close .fb-prev .fb-next");

	  if (self.idleInterval) {
		window.clearInterval(self.idleInterval);

		self.idleInterval = null;
	  }
	},

	// Change to previous gallery item
	// ===============================

	previous: function (duration) {
	  return this.jumpTo(this.currPos - 1, duration);
	},

	// Change to next gallery item
	// ===========================

	next: function (duration) {
	  return this.jumpTo(this.currPos + 1, duration);
	},

	// Switch to selected gallery item
	// ===============================

	jumpTo: function (pos, duration) {
	  var self = this,
		groupLen = self.group.length,
		firstRun,
		isMoved,
		loop,
		current,
		previous,
		slidePos,
		stagePos,
		prop,
		diff;

	  if (self.isDragging || self.isClosing || (self.isAnimating && self.firstRun)) {
		return;
	  }

	  // Should loop?
	  pos = parseInt(pos, 10);
	  loop = self.current ? self.current.opts.loop : self.opts.loop;

	  if (!loop && (pos < 0 || pos >= groupLen)) {
		return false;
	  }

	  // Check if opening for the first time; this helps to speed things up
	  firstRun = self.firstRun = !Object.keys(self.slides).length;

	  // Create slides
	  previous = self.current;

	  self.prevIndex = self.currIndex;
	  self.prevPos = self.currPos;

	  current = self.createSlide(pos);

	  if (groupLen > 1) {
		if (loop || current.index < groupLen - 1) {
		  self.createSlide(pos + 1);
		}

		if (loop || current.index > 0) {
		  self.createSlide(pos - 1);
		}
	  }

	  self.current = current;
	  self.currIndex = current.index;
	  self.currPos = current.pos;

	  self.trigger("beforeShow", firstRun);

	  self.updateControls();

	  // Validate duration length
	  current.forcedDuration = undefined;

	  if ($.isNumeric(duration)) {
		current.forcedDuration = duration;
	  } else {
		duration = current.opts[firstRun ? "animationDuration" : "transitionDuration"];
	  }

	  duration = parseInt(duration, 10);

	  // Check if user has swiped the slides or if still animating
	  isMoved = self.isMoved(current);

	  // Make sure current slide is visible
	  current.$slide.addClass("fancybox-slide--current");

	  // Fresh start - reveal container, current slide and start loading content
	  if (firstRun) {
		if (current.opts.animationEffect && duration) {
		  self.$refs.container.css("transition-duration", duration + "ms");
		}

		self.$refs.container.addClass("fancybox-is-open").trigger("focus");

		// Attempt to load content into slide
		// This will later call `afterLoad` -> `revealContent`
		self.loadSlide(current);

		self.preload("image");

		return;
	  }

	  // Get actual slide/stage positions (before cleaning up)
	  slidePos = $.fancybox.getTranslate(previous.$slide);
	  stagePos = $.fancybox.getTranslate(self.$refs.stage);

	  // Clean up all slides
	  $.each(self.slides, function (index, slide) {
		$.fancybox.stop(slide.$slide, true);
	  });

	  if (previous.pos !== current.pos) {
		previous.isComplete = false;
	  }

	  previous.$slide.removeClass("fancybox-slide--complete fancybox-slide--current");

	  // If slides are out of place, then animate them to correct position
	  if (isMoved) {
		// Calculate horizontal swipe distance
		diff = slidePos.left - (previous.pos * slidePos.width + previous.pos * previous.opts.gutter);

		$.each(self.slides, function (index, slide) {
		  slide.$slide.removeClass("fancybox-animated").removeClass(function (index, className) {
			return (className.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
		  });

		  // Make sure that each slide is in equal distance
		  // This is mostly needed for freshly added slides, because they are not yet positioned
		  var leftPos = slide.pos * slidePos.width + slide.pos * slide.opts.gutter;

		  $.fancybox.setTranslate(slide.$slide, {
			top: 0,
			left: leftPos - stagePos.left + diff
		  });

		  if (slide.pos !== current.pos) {
			slide.$slide.addClass("fancybox-slide--" + (slide.pos > current.pos ? "next" : "previous"));
		  }

		  // Redraw to make sure that transition will start
		  forceRedraw(slide.$slide);

		  // Animate the slide
		  $.fancybox.animate(
			slide.$slide, {
			  top: 0,
			  left: (slide.pos - current.pos) * slidePos.width + (slide.pos - current.pos) * slide.opts.gutter
			},
			duration,
			function () {
			  slide.$slide
				.css({
				  transform: "",
				  opacity: ""
				})
				.removeClass("fancybox-slide--next fancybox-slide--previous");

			  if (slide.pos === self.currPos) {
				self.complete();
			  }
			}
		  );
		});
	  } else if (duration && current.opts.transitionEffect) {
		// Set transition effect for previously active slide
		prop = "fancybox-animated fancybox-fx-" + current.opts.transitionEffect;

		previous.$slide.addClass("fancybox-slide--" + (previous.pos > current.pos ? "next" : "previous"));

		$.fancybox.animate(
		  previous.$slide,
		  prop,
		  duration,
		  function () {
			previous.$slide.removeClass(prop).removeClass("fancybox-slide--next fancybox-slide--previous");
		  },
		  false
		);
	  }

	  if (current.isLoaded) {
		self.revealContent(current);
	  } else {
		self.loadSlide(current);
	  }

	  self.preload("image");
	},

	// Create new "slide" element
	// These are gallery items  that are actually added to DOM
	// =======================================================

	createSlide: function (pos) {
	  var self = this,
		$slide,
		index;

	  index = pos % self.group.length;
	  index = index < 0 ? self.group.length + index : index;

	  if (!self.slides[pos] && self.group[index]) {
		$slide = $('<div class="fancybox-slide"></div>').appendTo(self.$refs.stage);

		self.slides[pos] = $.extend(true, {}, self.group[index], {
		  pos: pos,
		  $slide: $slide,
		  isLoaded: false
		});

		self.updateSlide(self.slides[pos]);
	  }

	  return self.slides[pos];
	},

	// Scale image to the actual size of the image;
	// x and y values should be relative to the slide
	// ==============================================

	scaleToActual: function (x, y, duration) {
	  var self = this,
		current = self.current,
		$content = current.$content,
		canvasWidth = $.fancybox.getTranslate(current.$slide).width,
		canvasHeight = $.fancybox.getTranslate(current.$slide).height,
		newImgWidth = current.width,
		newImgHeight = current.height,
		imgPos,
		posX,
		posY,
		scaleX,
		scaleY;

	  if (self.isAnimating || self.isMoved() || !$content || !(current.type == "image" && current.isLoaded && !current.hasError)) {
		return;
	  }

	  self.isAnimating = true;

	  $.fancybox.stop($content);

	  x = x === undefined ? canvasWidth * 0.5 : x;
	  y = y === undefined ? canvasHeight * 0.5 : y;

	  imgPos = $.fancybox.getTranslate($content);

	  imgPos.top -= $.fancybox.getTranslate(current.$slide).top;
	  imgPos.left -= $.fancybox.getTranslate(current.$slide).left;

	  scaleX = newImgWidth / imgPos.width;
	  scaleY = newImgHeight / imgPos.height;

	  // Get center position for original image
	  posX = canvasWidth * 0.5 - newImgWidth * 0.5;
	  posY = canvasHeight * 0.5 - newImgHeight * 0.5;

	  // Make sure image does not move away from edges
	  if (newImgWidth > canvasWidth) {
		posX = imgPos.left * scaleX - (x * scaleX - x);

		if (posX > 0) {
		  posX = 0;
		}

		if (posX < canvasWidth - newImgWidth) {
		  posX = canvasWidth - newImgWidth;
		}
	  }

	  if (newImgHeight > canvasHeight) {
		posY = imgPos.top * scaleY - (y * scaleY - y);

		if (posY > 0) {
		  posY = 0;
		}

		if (posY < canvasHeight - newImgHeight) {
		  posY = canvasHeight - newImgHeight;
		}
	  }

	  self.updateCursor(newImgWidth, newImgHeight);

	  $.fancybox.animate(
		$content, {
		  top: posY,
		  left: posX,
		  scaleX: scaleX,
		  scaleY: scaleY
		},
		duration || 366,
		function () {
		  self.isAnimating = false;
		}
	  );

	  // Stop slideshow
	  if (self.SlideShow && self.SlideShow.isActive) {
		self.SlideShow.stop();
	  }
	},

	// Scale image to fit inside parent element
	// ========================================

	scaleToFit: function (duration) {
	  var self = this,
		current = self.current,
		$content = current.$content,
		end;

	  if (self.isAnimating || self.isMoved() || !$content || !(current.type == "image" && current.isLoaded && !current.hasError)) {
		return;
	  }

	  self.isAnimating = true;

	  $.fancybox.stop($content);

	  end = self.getFitPos(current);

	  self.updateCursor(end.width, end.height);

	  $.fancybox.animate(
		$content, {
		  top: end.top,
		  left: end.left,
		  scaleX: end.width / $content.width(),
		  scaleY: end.height / $content.height()
		},
		duration || 366,
		function () {
		  self.isAnimating = false;
		}
	  );
	},

	// Calculate image size to fit inside viewport
	// ===========================================

	getFitPos: function (slide) {
	  var self = this,
		$content = slide.$content,
		$slide = slide.$slide,
		width = slide.width || slide.opts.width,
		height = slide.height || slide.opts.height,
		maxWidth,
		maxHeight,
		minRatio,
		aspectRatio,
		rez = {};

	  if (!slide.isLoaded || !$content || !$content.length) {
		return false;
	  }

	  maxWidth = $.fancybox.getTranslate(self.$refs.stage).width;
	  maxHeight = $.fancybox.getTranslate(self.$refs.stage).height;

	  maxWidth -=
		parseFloat($slide.css("paddingLeft")) +
		parseFloat($slide.css("paddingRight")) +
		parseFloat($content.css("marginLeft")) +
		parseFloat($content.css("marginRight"));

	  maxHeight -=
		parseFloat($slide.css("paddingTop")) +
		parseFloat($slide.css("paddingBottom")) +
		parseFloat($content.css("marginTop")) +
		parseFloat($content.css("marginBottom"));

	  if (!width || !height) {
		width = maxWidth;
		height = maxHeight;
	  }

	  minRatio = Math.min(1, maxWidth / width, maxHeight / height);

	  width = minRatio * width;
	  height = minRatio * height;

	  // Adjust width/height to precisely fit into container
	  if (width > maxWidth - 0.5) {
		width = maxWidth;
	  }

	  if (height > maxHeight - 0.5) {
		height = maxHeight;
	  }

	  if (slide.type === "image") {
		rez.top = Math.floor((maxHeight - height) * 0.5) + parseFloat($slide.css("paddingTop"));
		rez.left = Math.floor((maxWidth - width) * 0.5) + parseFloat($slide.css("paddingLeft"));
	  } else if (slide.contentType === "video") {
		// Force aspect ratio for the video
		// "I say the whole world must learn of our peaceful ways… by force!"
		aspectRatio = slide.opts.width && slide.opts.height ? width / height : slide.opts.ratio || 16 / 9;

		if (height > width / aspectRatio) {
		  height = width / aspectRatio;
		} else if (width > height * aspectRatio) {
		  width = height * aspectRatio;
		}
	  }

	  rez.width = width;
	  rez.height = height;

	  return rez;
	},

	// Update content size and position for all slides
	// ==============================================

	update: function (e) {
	  var self = this;

	  $.each(self.slides, function (key, slide) {
		self.updateSlide(slide, e);
	  });
	},

	// Update slide content position and size
	// ======================================

	updateSlide: function (slide, e) {
	  var self = this,
		$content = slide && slide.$content,
		width = slide.width || slide.opts.width,
		height = slide.height || slide.opts.height,
		$slide = slide.$slide;

	  // First, prevent caption overlap, if needed
	  self.adjustCaption(slide);

	  // Then resize content to fit inside the slide
	  if ($content && (width || height || slide.contentType === "video") && !slide.hasError) {
		$.fancybox.stop($content);

		$.fancybox.setTranslate($content, self.getFitPos(slide));

		if (slide.pos === self.currPos) {
		  self.isAnimating = false;

		  self.updateCursor();
		}
	  }

	  // Then some adjustments
	  self.adjustLayout(slide);

	  if ($slide.length) {
		$slide.trigger("refresh");

		if (slide.pos === self.currPos) {
		  self.$refs.toolbar
			.add(self.$refs.navigation.find(".fancybox-button--arrow_right"))
			.toggleClass("compensate-for-scrollbar", $slide.get(0).scrollHeight > $slide.get(0).clientHeight);
		}
	  }

	  self.trigger("onUpdate", slide, e);
	},

	// Horizontally center slide
	// =========================

	centerSlide: function (duration) {
	  var self = this,
		current = self.current,
		$slide = current.$slide;

	  if (self.isClosing || !current) {
		return;
	  }

	  $slide.siblings().css({
		transform: "",
		opacity: ""
	  });

	  $slide
		.parent()
		.children()
		.removeClass("fancybox-slide--previous fancybox-slide--next");

	  $.fancybox.animate(
		$slide, {
		  top: 0,
		  left: 0,
		  opacity: 1
		},
		duration === undefined ? 0 : duration,
		function () {
		  // Clean up
		  $slide.css({
			transform: "",
			opacity: ""
		  });

		  if (!current.isComplete) {
			self.complete();
		  }
		},
		false
	  );
	},

	// Check if current slide is moved (swiped)
	// ========================================

	isMoved: function (slide) {
	  var current = slide || this.current,
		slidePos,
		stagePos;

	  if (!current) {
		return false;
	  }

	  stagePos = $.fancybox.getTranslate(this.$refs.stage);
	  slidePos = $.fancybox.getTranslate(current.$slide);

	  return (
		!current.$slide.hasClass("fancybox-animated") &&
		(Math.abs(slidePos.top - stagePos.top) > 0.5 || Math.abs(slidePos.left - stagePos.left) > 0.5)
	  );
	},

	// Update cursor style depending if content can be zoomed
	// ======================================================

	updateCursor: function (nextWidth, nextHeight) {
	  var self = this,
		current = self.current,
		$container = self.$refs.container,
		canPan,
		isZoomable;

	  if (!current || self.isClosing || !self.Guestures) {
		return;
	  }

	  $container.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan");

	  canPan = self.canPan(nextWidth, nextHeight);

	  isZoomable = canPan ? true : self.isZoomable();

	  $container.toggleClass("fancybox-is-zoomable", isZoomable);

	  $("[data-fancybox-zoom]").prop("disabled", !isZoomable);

	  if (canPan) {
		$container.addClass("fancybox-can-pan");
	  } else if (
		isZoomable &&
		(current.opts.clickContent === "zoom" || ($.isFunction(current.opts.clickContent) && current.opts.clickContent(current) == "zoom"))
	  ) {
		$container.addClass("fancybox-can-zoomIn");
	  } else if (current.opts.touch && (current.opts.touch.vertical || self.group.length > 1) && current.contentType !== "video") {
		$container.addClass("fancybox-can-swipe");
	  }
	},

	// Check if current slide is zoomable
	// ==================================

	isZoomable: function () {
	  var self = this,
		current = self.current,
		fitPos;

	  // Assume that slide is zoomable if:
	  //   - image is still loading
	  //   - actual size of the image is smaller than available area
	  if (current && !self.isClosing && current.type === "image" && !current.hasError) {
		if (!current.isLoaded) {
		  return true;
		}

		fitPos = self.getFitPos(current);

		if (fitPos && (current.width > fitPos.width || current.height > fitPos.height)) {
		  return true;
		}
	  }

	  return false;
	},

	// Check if current image dimensions are smaller than actual
	// =========================================================

	isScaledDown: function (nextWidth, nextHeight) {
	  var self = this,
		rez = false,
		current = self.current,
		$content = current.$content;

	  if (nextWidth !== undefined && nextHeight !== undefined) {
		rez = nextWidth < current.width && nextHeight < current.height;
	  } else if ($content) {
		rez = $.fancybox.getTranslate($content);
		rez = rez.width < current.width && rez.height < current.height;
	  }

	  return rez;
	},

	// Check if image dimensions exceed parent element
	// ===============================================

	canPan: function (nextWidth, nextHeight) {
	  var self = this,
		current = self.current,
		pos = null,
		rez = false;

	  if (current.type === "image" && (current.isComplete || (nextWidth && nextHeight)) && !current.hasError) {
		rez = self.getFitPos(current);

		if (nextWidth !== undefined && nextHeight !== undefined) {
		  pos = {
			width: nextWidth,
			height: nextHeight
		  };
		} else if (current.isComplete) {
		  pos = $.fancybox.getTranslate(current.$content);
		}

		if (pos && rez) {
		  rez = Math.abs(pos.width - rez.width) > 1.5 || Math.abs(pos.height - rez.height) > 1.5;
		}
	  }

	  return rez;
	},

	// Load content into the slide
	// ===========================

	loadSlide: function (slide) {
	  var self = this,
		type,
		$slide,
		ajaxLoad;

	  if (slide.isLoading || slide.isLoaded) {
		return;
	  }

	  slide.isLoading = true;

	  if (self.trigger("beforeLoad", slide) === false) {
		slide.isLoading = false;

		return false;
	  }

	  type = slide.type;
	  $slide = slide.$slide;

	  $slide
		.off("refresh")
		.trigger("onReset")
		.addClass(slide.opts.slideClass);

	  // Create content depending on the type
	  switch (type) {
		case "image":
		  self.setImage(slide);

		  break;

		case "iframe":
		  self.setIframe(slide);

		  break;

		case "html":
		  self.setContent(slide, slide.src || slide.content);

		  break;

		case "video":
		  self.setContent(
			slide,
			slide.opts.video.tpl
			.replace(/\{\{src\}\}/gi, slide.src)
			.replace("{{format}}", slide.opts.videoFormat || slide.opts.video.format || "")
			.replace("{{poster}}", slide.thumb || "")
		  );

		  break;

		case "inline":
		  if ($(slide.src).length) {
			self.setContent(slide, $(slide.src));
		  } else {
			self.setError(slide);
		  }

		  break;

		case "ajax":
		  self.showLoading(slide);

		  ajaxLoad = $.ajax(
			$.extend({}, slide.opts.ajax.settings, {
			  url: slide.src,
			  success: function (data, textStatus) {
				if (textStatus === "success") {
				  self.setContent(slide, data);
				}
			  },
			  error: function (jqXHR, textStatus) {
				if (jqXHR && textStatus !== "abort") {
				  self.setError(slide);
				}
			  }
			})
		  );

		  $slide.one("onReset", function () {
			ajaxLoad.abort();
		  });

		  break;

		default:
		  self.setError(slide);

		  break;
	  }

	  return true;
	},

	// Use thumbnail image, if possible
	// ================================

	setImage: function (slide) {
	  var self = this,
		ghost;

	  // Check if need to show loading icon
	  setTimeout(function () {
		var $img = slide.$image;

		if (!self.isClosing && slide.isLoading && (!$img || !$img.length || !$img[0].complete) && !slide.hasError) {
		  self.showLoading(slide);
		}
	  }, 50);

	  //Check if image has srcset
	  self.checkSrcset(slide);

	  // This will be wrapper containing both ghost and actual image
	  slide.$content = $('<div class="fancybox-content"></div>')
		.addClass("fancybox-is-hidden")
		.appendTo(slide.$slide.addClass("fancybox-slide--image"));

	  // If we have a thumbnail, we can display it while actual image is loading
	  // Users will not stare at black screen and actual image will appear gradually
	  if (slide.opts.preload !== false && slide.opts.width && slide.opts.height && slide.thumb) {
		slide.width = slide.opts.width;
		slide.height = slide.opts.height;

		ghost = document.createElement("img");

		ghost.onerror = function () {
		  $(this).remove();

		  slide.$ghost = null;
		};

		ghost.onload = function () {
		  self.afterLoad(slide);
		};

		slide.$ghost = $(ghost)
		  .addClass("fancybox-image")
		  .appendTo(slide.$content)
		  .attr("src", slide.thumb);
	  }

	  // Start loading actual image
	  self.setBigImage(slide);
	},

	// Check if image has srcset and get the source
	// ============================================
	checkSrcset: function (slide) {
	  var srcset = slide.opts.srcset || slide.opts.image.srcset,
		found,
		temp,
		pxRatio,
		windowWidth;

	  // If we have "srcset", then we need to find first matching "src" value.
	  // This is necessary, because when you set an src attribute, the browser will preload the image
	  // before any javascript or even CSS is applied.
	  if (srcset) {
		pxRatio = window.devicePixelRatio || 1;
		windowWidth = window.innerWidth * pxRatio;

		temp = srcset.split(",").map(function (el) {
		  var ret = {};

		  el.trim()
			.split(/\s+/)
			.forEach(function (el, i) {
			  var value = parseInt(el.substring(0, el.length - 1), 10);

			  if (i === 0) {
				return (ret.url = el);
			  }

			  if (value) {
				ret.value = value;
				ret.postfix = el[el.length - 1];
			  }
			});

		  return ret;
		});

		// Sort by value
		temp.sort(function (a, b) {
		  return a.value - b.value;
		});

		// Ok, now we have an array of all srcset values
		for (var j = 0; j < temp.length; j++) {
		  var el = temp[j];

		  if ((el.postfix === "w" && el.value >= windowWidth) || (el.postfix === "x" && el.value >= pxRatio)) {
			found = el;
			break;
		  }
		}

		// If not found, take the last one
		if (!found && temp.length) {
		  found = temp[temp.length - 1];
		}

		if (found) {
		  slide.src = found.url;

		  // If we have default width/height values, we can calculate height for matching source
		  if (slide.width && slide.height && found.postfix == "w") {
			slide.height = (slide.width / slide.height) * found.value;
			slide.width = found.value;
		  }

		  slide.opts.srcset = srcset;
		}
	  }
	},

	// Create full-size image
	// ======================

	setBigImage: function (slide) {
	  var self = this,
		img = document.createElement("img"),
		$img = $(img);

	  slide.$image = $img
		.one("error", function () {
		  self.setError(slide);
		})
		.one("load", function () {
		  var sizes;

		  if (!slide.$ghost) {
			self.resolveImageSlideSize(slide, this.naturalWidth, this.naturalHeight);

			self.afterLoad(slide);
		  }

		  if (self.isClosing) {
			return;
		  }

		  if (slide.opts.srcset) {
			sizes = slide.opts.sizes;

			if (!sizes || sizes === "auto") {
			  sizes =
				(slide.width / slide.height > 1 && $W.width() / $W.height() > 1 ? "100" : Math.round((slide.width / slide.height) * 100)) +
				"vw";
			}

			$img.attr("sizes", sizes).attr("srcset", slide.opts.srcset);
		  }

		  // Hide temporary image after some delay
		  if (slide.$ghost) {
			setTimeout(function () {
			  if (slide.$ghost && !self.isClosing) {
				slide.$ghost.hide();
			  }
			}, Math.min(300, Math.max(1000, slide.height / 1600)));
		  }

		  self.hideLoading(slide);
		})
		.addClass("fancybox-image")
		.attr("src", slide.src)
		.appendTo(slide.$content);

	  if ((img.complete || img.readyState == "complete") && $img.naturalWidth && $img.naturalHeight) {
		$img.trigger("load");
	  } else if (img.error) {
		$img.trigger("error");
	  }
	},

	// Computes the slide size from image size and maxWidth/maxHeight
	// ==============================================================

	resolveImageSlideSize: function (slide, imgWidth, imgHeight) {
	  var maxWidth = parseInt(slide.opts.width, 10),
		maxHeight = parseInt(slide.opts.height, 10);

	  // Sets the default values from the image
	  slide.width = imgWidth;
	  slide.height = imgHeight;

	  if (maxWidth > 0) {
		slide.width = maxWidth;
		slide.height = Math.floor((maxWidth * imgHeight) / imgWidth);
	  }

	  if (maxHeight > 0) {
		slide.width = Math.floor((maxHeight * imgWidth) / imgHeight);
		slide.height = maxHeight;
	  }
	},

	// Create iframe wrapper, iframe and bindings
	// ==========================================

	setIframe: function (slide) {
	  var self = this,
		opts = slide.opts.iframe,
		$slide = slide.$slide,
		$iframe;

	  slide.$content = $('<div class="fancybox-content' + (opts.preload ? " fancybox-is-hidden" : "") + '"></div>')
		.css(opts.css)
		.appendTo($slide);

	  $slide.addClass("fancybox-slide--" + slide.contentType);

	  slide.$iframe = $iframe = $(opts.tpl.replace(/\{rnd\}/g, new Date().getTime()))
		.attr(opts.attr)
		.appendTo(slide.$content);

	  if (opts.preload) {
		self.showLoading(slide);

		// Unfortunately, it is not always possible to determine if iframe is successfully loaded
		// (due to browser security policy)

		$iframe.on("load.fb error.fb", function (e) {
		  this.isReady = 1;

		  slide.$slide.trigger("refresh");

		  self.afterLoad(slide);
		});

		// Recalculate iframe content size
		// ===============================

		$slide.on("refresh.fb", function () {
		  var $content = slide.$content,
			frameWidth = opts.css.width,
			frameHeight = opts.css.height,
			$contents,
			$body;

		  if ($iframe[0].isReady !== 1) {
			return;
		  }

		  try {
			$contents = $iframe.contents();
			$body = $contents.find("body");
		  } catch (ignore) {}

		  // Calculate content dimensions, if it is accessible
		  if ($body && $body.length && $body.children().length) {
			// Avoid scrolling to top (if multiple instances)
			$slide.css("overflow", "visible");

			$content.css({
			  width: "100%",
			  "max-width": "100%",
			  height: "9999px"
			});

			if (frameWidth === undefined) {
			  frameWidth = Math.ceil(Math.max($body[0].clientWidth, $body.outerWidth(true)));
			}

			$content.css("width", frameWidth ? frameWidth : "").css("max-width", "");

			if (frameHeight === undefined) {
			  frameHeight = Math.ceil(Math.max($body[0].clientHeight, $body.outerHeight(true)));
			}

			$content.css("height", frameHeight ? frameHeight : "");

			$slide.css("overflow", "auto");
		  }

		  $content.removeClass("fancybox-is-hidden");
		});
	  } else {
		self.afterLoad(slide);
	  }

	  $iframe.attr("src", slide.src);

	  // Remove iframe if closing or changing gallery item
	  $slide.one("onReset", function () {
		// This helps IE not to throw errors when closing
		try {
		  $(this)
			.find("iframe")
			.hide()
			.unbind()
			.attr("src", "//about:blank");
		} catch (ignore) {}

		$(this)
		  .off("refresh.fb")
		  .empty();

		slide.isLoaded = false;
		slide.isRevealed = false;
	  });
	},

	// Wrap and append content to the slide
	// ======================================

	setContent: function (slide, content) {
	  var self = this;

	  if (self.isClosing) {
		return;
	  }

	  self.hideLoading(slide);

	  if (slide.$content) {
		$.fancybox.stop(slide.$content);
	  }

	  slide.$slide.empty();

	  // If content is a jQuery object, then it will be moved to the slide.
	  // The placeholder is created so we will know where to put it back.
	  if (isQuery(content) && content.parent().length) {
		// Make sure content is not already moved to fancyBox
		if (content.hasClass("fancybox-content") || content.parent().hasClass("fancybox-content")) {
		  content.parents(".fancybox-slide").trigger("onReset");
		}

		// Create temporary element marking original place of the content
		slide.$placeholder = $("<div>")
		  .hide()
		  .insertAfter(content);

		// Make sure content is visible
		content.css("display", "inline-block");
	  } else if (!slide.hasError) {
		// If content is just a plain text, try to convert it to html
		if ($.type(content) === "string") {
		  content = $("<div>")
			.append($.trim(content))
			.contents();
		}

		// If "filter" option is provided, then filter content
		if (slide.opts.filter) {
		  content = $("<div>")
			.html(content)
			.find(slide.opts.filter);
		}
	  }

	  slide.$slide.one("onReset", function () {
		// Pause all html5 video/audio
		$(this)
		  .find("video,audio")
		  .trigger("pause");

		// Put content back
		if (slide.$placeholder) {
		  slide.$placeholder.after(content.removeClass("fancybox-content").hide()).remove();

		  slide.$placeholder = null;
		}

		// Remove custom close button
		if (slide.$smallBtn) {
		  slide.$smallBtn.remove();

		  slide.$smallBtn = null;
		}

		// Remove content and mark slide as not loaded
		if (!slide.hasError) {
		  $(this).empty();

		  slide.isLoaded = false;
		  slide.isRevealed = false;
		}
	  });

	  $(content).appendTo(slide.$slide);

	  if ($(content).is("video,audio")) {
		$(content).addClass("fancybox-video");

		$(content).wrap("<div></div>");

		slide.contentType = "video";

		slide.opts.width = slide.opts.width || $(content).attr("width");
		slide.opts.height = slide.opts.height || $(content).attr("height");
	  }

	  slide.$content = slide.$slide
		.children()
		.filter("div,form,main,video,audio,article,.fancybox-content")
		.first();

	  slide.$content.siblings().hide();

	  // Re-check if there is a valid content
	  // (in some cases, ajax response can contain various elements or plain text)
	  if (!slide.$content.length) {
		slide.$content = slide.$slide
		  .wrapInner("<div></div>")
		  .children()
		  .first();
	  }

	  slide.$content.addClass("fancybox-content");

	  slide.$slide.addClass("fancybox-slide--" + slide.contentType);

	  self.afterLoad(slide);
	},

	// Display error message
	// =====================

	setError: function (slide) {
	  slide.hasError = true;

	  slide.$slide
		.trigger("onReset")
		.removeClass("fancybox-slide--" + slide.contentType)
		.addClass("fancybox-slide--error");

	  slide.contentType = "html";

	  this.setContent(slide, this.translate(slide, slide.opts.errorTpl));

	  if (slide.pos === this.currPos) {
		this.isAnimating = false;
	  }
	},

	// Show loading icon inside the slide
	// ==================================

	showLoading: function (slide) {
	  var self = this;

	  slide = slide || self.current;

	  if (slide && !slide.$spinner) {
		slide.$spinner = $(self.translate(self, self.opts.spinnerTpl))
		  .appendTo(slide.$slide)
		  .hide()
		  .fadeIn("fast");
	  }
	},

	// Remove loading icon from the slide
	// ==================================

	hideLoading: function (slide) {
	  var self = this;

	  slide = slide || self.current;

	  if (slide && slide.$spinner) {
		slide.$spinner.stop().remove();

		delete slide.$spinner;
	  }
	},

	// Adjustments after slide content has been loaded
	// ===============================================

	afterLoad: function (slide) {
	  var self = this;

	  if (self.isClosing) {
		return;
	  }

	  slide.isLoading = false;
	  slide.isLoaded = true;

	  self.trigger("afterLoad", slide);

	  self.hideLoading(slide);

	  // Add small close button
	  if (slide.opts.smallBtn && (!slide.$smallBtn || !slide.$smallBtn.length)) {
		slide.$smallBtn = $(self.translate(slide, slide.opts.btnTpl.smallBtn)).appendTo(slide.$content);
	  }

	  // Disable right click
	  if (slide.opts.protect && slide.$content && !slide.hasError) {
		slide.$content.on("contextmenu.fb", function (e) {
		  if (e.button == 2) {
			e.preventDefault();
		  }

		  return true;
		});

		// Add fake element on top of the image
		// This makes a bit harder for user to select image
		if (slide.type === "image") {
		  $('<div class="fancybox-spaceball"></div>').appendTo(slide.$content);
		}
	  }

	  self.adjustCaption(slide);

	  self.adjustLayout(slide);

	  if (slide.pos === self.currPos) {
		self.updateCursor();
	  }

	  self.revealContent(slide);
	},

	// Prevent caption overlap,
	// fix css inconsistency across browsers
	// =====================================

	adjustCaption: function (slide) {
	  var self = this,
		current = slide || self.current,
		caption = current.opts.caption,
		preventOverlap = current.opts.preventCaptionOverlap,
		$caption = self.$refs.caption,
		$clone,
		captionH = false;

	  $caption.toggleClass("fancybox-caption--separate", preventOverlap);

	  if (preventOverlap && caption && caption.length) {
		if (current.pos !== self.currPos) {
		  $clone = $caption.clone().appendTo($caption.parent());

		  $clone
			.children()
			.eq(0)
			.empty()
			.html(caption);

		  captionH = $clone.outerHeight(true);

		  $clone.empty().remove();
		} else if (self.$caption) {
		  captionH = self.$caption.outerHeight(true);
		}

		current.$slide.css("padding-bottom", captionH || "");
	  }
	},

	// Simple hack to fix inconsistency across browsers, described here (affects Edge, too):
	// https://bugzilla.mozilla.org/show_bug.cgi?id=748518
	// ====================================================================================

	adjustLayout: function (slide) {
	  var self = this,
		current = slide || self.current,
		scrollHeight,
		marginBottom,
		inlinePadding,
		actualPadding;

	  if (current.isLoaded && current.opts.disableLayoutFix !== true) {
		current.$content.css("margin-bottom", "");

		// If we would always set margin-bottom for the content,
		// then it would potentially break vertical align
		if (current.$content.outerHeight() > current.$slide.height() + 0.5) {
		  inlinePadding = current.$slide[0].style["padding-bottom"];
		  actualPadding = current.$slide.css("padding-bottom");

		  if (parseFloat(actualPadding) > 0) {
			scrollHeight = current.$slide[0].scrollHeight;

			current.$slide.css("padding-bottom", 0);

			if (Math.abs(scrollHeight - current.$slide[0].scrollHeight) < 1) {
			  marginBottom = actualPadding;
			}

			current.$slide.css("padding-bottom", inlinePadding);
		  }
		}

		current.$content.css("margin-bottom", marginBottom);
	  }
	},

	// Make content visible
	// This method is called right after content has been loaded or
	// user navigates gallery and transition should start
	// ============================================================

	revealContent: function (slide) {
	  var self = this,
		$slide = slide.$slide,
		end = false,
		start = false,
		isMoved = self.isMoved(slide),
		isRevealed = slide.isRevealed,
		effect,
		effectClassName,
		duration,
		opacity;

	  slide.isRevealed = true;

	  effect = slide.opts[self.firstRun ? "animationEffect" : "transitionEffect"];
	  duration = slide.opts[self.firstRun ? "animationDuration" : "transitionDuration"];

	  duration = parseInt(slide.forcedDuration === undefined ? duration : slide.forcedDuration, 10);

	  if (isMoved || slide.pos !== self.currPos || !duration) {
		effect = false;
	  }

	  // Check if can zoom
	  if (effect === "zoom") {
		if (slide.pos === self.currPos && duration && slide.type === "image" && !slide.hasError && (start = self.getThumbPos(slide))) {
		  end = self.getFitPos(slide);
		} else {
		  effect = "fade";
		}
	  }

	  // Zoom animation
	  // ==============
	  if (effect === "zoom") {
		self.isAnimating = true;

		end.scaleX = end.width / start.width;
		end.scaleY = end.height / start.height;

		// Check if we need to animate opacity
		opacity = slide.opts.zoomOpacity;

		if (opacity == "auto") {
		  opacity = Math.abs(slide.width / slide.height - start.width / start.height) > 0.1;
		}

		if (opacity) {
		  start.opacity = 0.1;
		  end.opacity = 1;
		}

		// Draw image at start position
		$.fancybox.setTranslate(slide.$content.removeClass("fancybox-is-hidden"), start);

		forceRedraw(slide.$content);

		// Start animation
		$.fancybox.animate(slide.$content, end, duration, function () {
		  self.isAnimating = false;

		  self.complete();
		});

		return;
	  }

	  self.updateSlide(slide);

	  // Simply show content if no effect
	  // ================================
	  if (!effect) {
		slide.$content.removeClass("fancybox-is-hidden");

		if (!isRevealed && isMoved && slide.type === "image" && !slide.hasError) {
		  slide.$content.hide().fadeIn("fast");
		}

		if (slide.pos === self.currPos) {
		  self.complete();
		}

		return;
	  }

	  // Prepare for CSS transiton
	  // =========================
	  $.fancybox.stop($slide);

	  //effectClassName = "fancybox-animated fancybox-slide--" + (slide.pos >= self.prevPos ? "next" : "previous") + " fancybox-fx-" + effect;
	  effectClassName = "fancybox-slide--" + (slide.pos >= self.prevPos ? "next" : "previous") + " fancybox-animated fancybox-fx-" + effect;

	  $slide.addClass(effectClassName).removeClass("fancybox-slide--current"); //.addClass(effectClassName);

	  slide.$content.removeClass("fancybox-is-hidden");

	  // Force reflow
	  forceRedraw($slide);

	  if (slide.type !== "image") {
		slide.$content.hide().show(0);
	  }

	  $.fancybox.animate(
		$slide,
		"fancybox-slide--current",
		duration,
		function () {
		  $slide.removeClass(effectClassName).css({
			transform: "",
			opacity: ""
		  });

		  if (slide.pos === self.currPos) {
			self.complete();
		  }
		},
		true
	  );
	},

	// Check if we can and have to zoom from thumbnail
	//================================================

	getThumbPos: function (slide) {
	  var rez = false,
		$thumb = slide.$thumb,
		thumbPos,
		btw,
		brw,
		bbw,
		blw;

	  if (!$thumb || !inViewport($thumb[0])) {
		return false;
	  }

	  thumbPos = $.fancybox.getTranslate($thumb);

	  btw = parseFloat($thumb.css("border-top-width") || 0);
	  brw = parseFloat($thumb.css("border-right-width") || 0);
	  bbw = parseFloat($thumb.css("border-bottom-width") || 0);
	  blw = parseFloat($thumb.css("border-left-width") || 0);

	  rez = {
		top: thumbPos.top + btw,
		left: thumbPos.left + blw,
		width: thumbPos.width - brw - blw,
		height: thumbPos.height - btw - bbw,
		scaleX: 1,
		scaleY: 1
	  };

	  return thumbPos.width > 0 && thumbPos.height > 0 ? rez : false;
	},

	// Final adjustments after current gallery item is moved to position
	// and it`s content is loaded
	// ==================================================================

	complete: function () {
	  var self = this,
		current = self.current,
		slides = {},
		$el;

	  if (self.isMoved() || !current.isLoaded) {
		return;
	  }

	  if (!current.isComplete) {
		current.isComplete = true;

		current.$slide.siblings().trigger("onReset");

		self.preload("inline");

		// Trigger any CSS transiton inside the slide
		forceRedraw(current.$slide);

		current.$slide.addClass("fancybox-slide--complete");

		// Remove unnecessary slides
		$.each(self.slides, function (key, slide) {
		  if (slide.pos >= self.currPos - 1 && slide.pos <= self.currPos + 1) {
			slides[slide.pos] = slide;
		  } else if (slide) {
			$.fancybox.stop(slide.$slide);

			slide.$slide.off().remove();
		  }
		});

		self.slides = slides;
	  }

	  self.isAnimating = false;

	  self.updateCursor();

	  self.trigger("afterShow");

	  // Autoplay first html5 video/audio
	  if (!!current.opts.video.autoStart) {
		current.$slide
		  .find("video,audio")
		  .filter(":visible:first")
		  .trigger("play")
		  .one("ended", function () {
			if (Document.exitFullscreen) {
			  Document.exitFullscreen();
			} else if (this.webkitExitFullscreen) {
			  this.webkitExitFullscreen();
			}

			self.next();
		  });
	  }

	  // Try to focus on the first focusable element
	  if (current.opts.autoFocus && current.contentType === "html") {
		// Look for the first input with autofocus attribute
		$el = current.$content.find("input[autofocus]:enabled:visible:first");

		if ($el.length) {
		  $el.trigger("focus");
		} else {
		  self.focus(null, true);
		}
	  }

	  // Avoid jumping
	  current.$slide.scrollTop(0).scrollLeft(0);
	},

	// Preload next and previous slides
	// ================================

	preload: function (type) {
	  var self = this,
		prev,
		next;

	  if (self.group.length < 2) {
		return;
	  }

	  next = self.slides[self.currPos + 1];
	  prev = self.slides[self.currPos - 1];

	  if (prev && prev.type === type) {
		self.loadSlide(prev);
	  }

	  if (next && next.type === type) {
		self.loadSlide(next);
	  }
	},

	// Try to find and focus on the first focusable element
	// ====================================================

	focus: function (e, firstRun) {
	  var self = this,
		focusableStr = [
		  "a[href]",
		  "area[href]",
		  'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
		  "select:not([disabled]):not([aria-hidden])",
		  "textarea:not([disabled]):not([aria-hidden])",
		  "button:not([disabled]):not([aria-hidden])",
		  "iframe",
		  "object",
		  "embed",
		  "video",
		  "audio",
		  "[contenteditable]",
		  '[tabindex]:not([tabindex^="-"])'
		].join(","),
		focusableItems,
		focusedItemIndex;

	  if (self.isClosing) {
		return;
	  }

	  if (e || !self.current || !self.current.isComplete) {
		// Focus on any element inside fancybox
		focusableItems = self.$refs.container.find("*:visible");
	  } else {
		// Focus inside current slide
		focusableItems = self.current.$slide.find("*:visible" + (firstRun ? ":not(.fancybox-close-small)" : ""));
	  }

	  focusableItems = focusableItems.filter(focusableStr).filter(function () {
		return $(this).css("visibility") !== "hidden" && !$(this).hasClass("disabled");
	  });

	  if (focusableItems.length) {
		focusedItemIndex = focusableItems.index(document.activeElement);

		if (e && e.shiftKey) {
		  // Back tab
		  if (focusedItemIndex < 0 || focusedItemIndex == 0) {
			e.preventDefault();

			focusableItems.eq(focusableItems.length - 1).trigger("focus");
		  }
		} else {
		  // Outside or Forward tab
		  if (focusedItemIndex < 0 || focusedItemIndex == focusableItems.length - 1) {
			if (e) {
			  e.preventDefault();
			}

			focusableItems.eq(0).trigger("focus");
		  }
		}
	  } else {
		self.$refs.container.trigger("focus");
	  }
	},

	// Activates current instance - brings container to the front and enables keyboard,
	// notifies other instances about deactivating
	// =================================================================================

	activate: function () {
	  var self = this;

	  // Deactivate all instances
	  $(".fancybox-container").each(function () {
		var instance = $(this).data("FancyBox");

		// Skip self and closing instances
		if (instance && instance.id !== self.id && !instance.isClosing) {
		  instance.trigger("onDeactivate");

		  instance.removeEvents();

		  instance.isVisible = false;
		}
	  });

	  self.isVisible = true;

	  if (self.current || self.isIdle) {
		self.update();

		self.updateControls();
	  }

	  self.trigger("onActivate");

	  self.addEvents();
	},

	// Start closing procedure
	// This will start "zoom-out" animation if needed and clean everything up afterwards
	// =================================================================================

	close: function (e, d) {
	  var self = this,
		current = self.current,
		effect,
		duration,
		$content,
		domRect,
		opacity,
		start,
		end;

	  var done = function () {
		self.cleanUp(e);
	  };

	  if (self.isClosing) {
		return false;
	  }

	  self.isClosing = true;

	  // If beforeClose callback prevents closing, make sure content is centered
	  if (self.trigger("beforeClose", e) === false) {
		self.isClosing = false;

		requestAFrame(function () {
		  self.update();
		});

		return false;
	  }

	  // Remove all events
	  // If there are multiple instances, they will be set again by "activate" method
	  self.removeEvents();

	  $content = current.$content;
	  effect = current.opts.animationEffect;
	  duration = $.isNumeric(d) ? d : effect ? current.opts.animationDuration : 0;

	  current.$slide.removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated");

	  if (e !== true) {
		$.fancybox.stop(current.$slide);
	  } else {
		effect = false;
	  }

	  // Remove other slides
	  current.$slide
		.siblings()
		.trigger("onReset")
		.remove();

	  // Trigger animations
	  if (duration) {
		self.$refs.container
		  .removeClass("fancybox-is-open")
		  .addClass("fancybox-is-closing")
		  .css("transition-duration", duration + "ms");
	  }

	  // Clean up
	  self.hideLoading(current);

	  self.hideControls(true);

	  self.updateCursor();

	  // Check if possible to zoom-out
	  if (
		effect === "zoom" &&
		!($content && duration && current.type === "image" && !self.isMoved() && !current.hasError && (end = self.getThumbPos(current)))
	  ) {
		effect = "fade";
	  }

	  if (effect === "zoom") {
		$.fancybox.stop($content);

		domRect = $.fancybox.getTranslate($content);

		start = {
		  top: domRect.top,
		  left: domRect.left,
		  scaleX: domRect.width / end.width,
		  scaleY: domRect.height / end.height,
		  width: end.width,
		  height: end.height
		};

		// Check if we need to animate opacity
		opacity = current.opts.zoomOpacity;

		if (opacity == "auto") {
		  opacity = Math.abs(current.width / current.height - end.width / end.height) > 0.1;
		}

		if (opacity) {
		  end.opacity = 0;
		}

		$.fancybox.setTranslate($content, start);

		forceRedraw($content);

		$.fancybox.animate($content, end, duration, done);

		return true;
	  }

	  if (effect && duration) {
		$.fancybox.animate(
		  current.$slide.addClass("fancybox-slide--previous").removeClass("fancybox-slide--current"),
		  "fancybox-animated fancybox-fx-" + effect,
		  duration,
		  done
		);
	  } else {
		// If skip animation
		if (e === true) {
		  setTimeout(done, duration);
		} else {
		  done();
		}
	  }

	  return true;
	},

	// Final adjustments after removing the instance
	// =============================================

	cleanUp: function (e) {
	  var self = this,
		instance,
		$focus = self.current.opts.$orig,
		x,
		y;

	  self.current.$slide.trigger("onReset");

	  self.$refs.container.empty().remove();

	  self.trigger("afterClose", e);

	  // Place back focus
	  if (!!self.current.opts.backFocus) {
		if (!$focus || !$focus.length || !$focus.is(":visible")) {
		  $focus = self.$trigger;
		}

		if ($focus && $focus.length) {
		  x = window.scrollX;
		  y = window.scrollY;

		  $focus.trigger("focus");

		  $("html, body")
			.scrollTop(y)
			.scrollLeft(x);
		}
	  }

	  self.current = null;

	  // Check if there are other instances
	  instance = $.fancybox.getInstance();

	  if (instance) {
		instance.activate();
	  } else {
		$("body").removeClass("fancybox-active compensate-for-scrollbar");

		$("#fancybox-style-noscroll").remove();
	  }
	},

	// Call callback and trigger an event
	// ==================================

	trigger: function (name, slide) {
	  var args = Array.prototype.slice.call(arguments, 1),
		self = this,
		obj = slide && slide.opts ? slide : self.current,
		rez;

	  if (obj) {
		args.unshift(obj);
	  } else {
		obj = self;
	  }

	  args.unshift(self);

	  if ($.isFunction(obj.opts[name])) {
		rez = obj.opts[name].apply(obj, args);
	  }

	  if (rez === false) {
		return rez;
	  }

	  if (name === "afterClose" || !self.$refs) {
		$D.trigger(name + ".fb", args);
	  } else {
		self.$refs.container.trigger(name + ".fb", args);
	  }
	},

	// Update infobar values, navigation button states and reveal caption
	// ==================================================================

	updateControls: function () {
	  var self = this,
		current = self.current,
		index = current.index,
		$container = self.$refs.container,
		$caption = self.$refs.caption,
		caption = current.opts.caption;

	  // Recalculate content dimensions
	  current.$slide.trigger("refresh");

	  // Set caption
	  if (caption && caption.length) {
		self.$caption = $caption;

		$caption
		  .children()
		  .eq(0)
		  .html(caption);
	  } else {
		self.$caption = null;
	  }

	  if (!self.hasHiddenControls && !self.isIdle) {
		self.showControls();
	  }

	  // Update info and navigation elements
	  $container.find("[data-fancybox-count]").html(self.group.length);
	  $container.find("[data-fancybox-index]").html(index + 1);

	  $container.find("[data-fancybox-prev]").prop("disabled", !current.opts.loop && index <= 0);
	  $container.find("[data-fancybox-next]").prop("disabled", !current.opts.loop && index >= self.group.length - 1);

	  if (current.type === "image") {
		// Re-enable buttons; update download button source
		$container
		  .find("[data-fancybox-zoom]")
		  .show()
		  .end()
		  .find("[data-fancybox-download]")
		  .attr("href", current.opts.image.src || current.src)
		  .show();
	  } else if (current.opts.toolbar) {
		$container.find("[data-fancybox-download],[data-fancybox-zoom]").hide();
	  }

	  // Make sure focus is not on disabled button/element
	  if ($(document.activeElement).is(":hidden,[disabled]")) {
		self.$refs.container.trigger("focus");
	  }
	},

	// Hide toolbar and caption
	// ========================

	hideControls: function (andCaption) {
	  var self = this,
		arr = ["infobar", "toolbar", "nav"];

	  if (andCaption || !self.current.opts.preventCaptionOverlap) {
		arr.push("caption");
	  }

	  this.$refs.container.removeClass(
		arr
		.map(function (i) {
		  return "fancybox-show-" + i;
		})
		.join(" ")
	  );

	  this.hasHiddenControls = true;
	},

	showControls: function () {
	  var self = this,
		opts = self.current ? self.current.opts : self.opts,
		$container = self.$refs.container;

	  self.hasHiddenControls = false;
	  self.idleSecondsCounter = 0;

	  $container
		.toggleClass("fancybox-show-toolbar", !!(opts.toolbar && opts.buttons))
		.toggleClass("fancybox-show-infobar", !!(opts.infobar && self.group.length > 1))
		.toggleClass("fancybox-show-caption", !!self.$caption)
		.toggleClass("fancybox-show-nav", !!(opts.arrows && self.group.length > 1))
		.toggleClass("fancybox-is-modal", !!opts.modal);
	},

	// Toggle toolbar and caption
	// ==========================

	toggleControls: function () {
	  if (this.hasHiddenControls) {
		this.showControls();
	  } else {
		this.hideControls();
	  }
	}
  });

  $.fancybox = {
	version: "{fancybox-version}",
	defaults: defaults,

	// Get current instance and execute a command.
	//
	// Examples of usage:
	//
	//   $instance = $.fancybox.getInstance();
	//   $.fancybox.getInstance().jumpTo( 1 );
	//   $.fancybox.getInstance( 'jumpTo', 1 );
	//   $.fancybox.getInstance( function() {
	//       console.info( this.currIndex );
	//   });
	// ======================================================

	getInstance: function (command) {
	  var instance = $('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox"),
		args = Array.prototype.slice.call(arguments, 1);

	  if (instance instanceof FancyBox) {
		if ($.type(command) === "string") {
		  instance[command].apply(instance, args);
		} else if ($.type(command) === "function") {
		  command.apply(instance, args);
		}

		return instance;
	  }

	  return false;
	},

	// Create new instance
	// ===================

	open: function (items, opts, index) {
	  return new FancyBox(items, opts, index);
	},

	// Close current or all instances
	// ==============================

	close: function (all) {
	  var instance = this.getInstance();

	  if (instance) {
		instance.close();

		// Try to find and close next instance
		if (all === true) {
		  this.close(all);
		}
	  }
	},

	// Close all instances and unbind all events
	// =========================================

	destroy: function () {
	  this.close(true);

	  $D.add("body").off("click.fb-start", "**");
	},

	// Try to detect mobile devices
	// ============================

	isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),

	// Detect if 'translate3d' support is available
	// ============================================

	use3d: (function () {
	  var div = document.createElement("div");

	  return (
		window.getComputedStyle &&
		window.getComputedStyle(div) &&
		window.getComputedStyle(div).getPropertyValue("transform") &&
		!(document.documentMode && document.documentMode < 11)
	  );
	})(),

	// Helper function to get current visual state of an element
	// returns array[ top, left, horizontal-scale, vertical-scale, opacity ]
	// =====================================================================

	getTranslate: function ($el) {
	  var domRect;

	  if (!$el || !$el.length) {
		return false;
	  }

	  domRect = $el[0].getBoundingClientRect();

	  return {
		top: domRect.top || 0,
		left: domRect.left || 0,
		width: domRect.width,
		height: domRect.height,
		opacity: parseFloat($el.css("opacity"))
	  };
	},

	// Shortcut for setting "translate3d" properties for element
	// Can set be used to set opacity, too
	// ========================================================

	setTranslate: function ($el, props) {
	  var str = "",
		css = {};

	  if (!$el || !props) {
		return;
	  }

	  if (props.left !== undefined || props.top !== undefined) {
		str =
		  (props.left === undefined ? $el.position().left : props.left) +
		  "px, " +
		  (props.top === undefined ? $el.position().top : props.top) +
		  "px";

		if (this.use3d) {
		  str = "translate3d(" + str + ", 0px)";
		} else {
		  str = "translate(" + str + ")";
		}
	  }

	  if (props.scaleX !== undefined && props.scaleY !== undefined) {
		str += " scale(" + props.scaleX + ", " + props.scaleY + ")";
	  } else if (props.scaleX !== undefined) {
		str += " scaleX(" + props.scaleX + ")";
	  }

	  if (str.length) {
		css.transform = str;
	  }

	  if (props.opacity !== undefined) {
		css.opacity = props.opacity;
	  }

	  if (props.width !== undefined) {
		css.width = props.width;
	  }

	  if (props.height !== undefined) {
		css.height = props.height;
	  }

	  return $el.css(css);
	},

	// Simple CSS transition handler
	// =============================

	animate: function ($el, to, duration, callback, leaveAnimationName) {
	  var self = this,
		from;

	  if ($.isFunction(duration)) {
		callback = duration;
		duration = null;
	  }

	  self.stop($el);

	  from = self.getTranslate($el);

	  $el.on(transitionEnd, function (e) {
		// Skip events from child elements and z-index change
		if (e && e.originalEvent && (!$el.is(e.originalEvent.target) || e.originalEvent.propertyName == "z-index")) {
		  return;
		}

		self.stop($el);

		if ($.isNumeric(duration)) {
		  $el.css("transition-duration", "");
		}

		if ($.isPlainObject(to)) {
		  if (to.scaleX !== undefined && to.scaleY !== undefined) {
			self.setTranslate($el, {
			  top: to.top,
			  left: to.left,
			  width: from.width * to.scaleX,
			  height: from.height * to.scaleY,
			  scaleX: 1,
			  scaleY: 1
			});
		  }
		} else if (leaveAnimationName !== true) {
		  $el.removeClass(to);
		}

		if ($.isFunction(callback)) {
		  callback(e);
		}
	  });

	  if ($.isNumeric(duration)) {
		$el.css("transition-duration", duration + "ms");
	  }

	  // Start animation by changing CSS properties or class name
	  if ($.isPlainObject(to)) {
		if (to.scaleX !== undefined && to.scaleY !== undefined) {
		  delete to.width;
		  delete to.height;

		  if ($el.parent().hasClass("fancybox-slide--image")) {
			$el.parent().addClass("fancybox-is-scaling");
		  }
		}

		$.fancybox.setTranslate($el, to);
	  } else {
		$el.addClass(to);
	  }

	  // Make sure that `transitionend` callback gets fired
	  $el.data(
		"timer",
		setTimeout(function () {
		  $el.trigger(transitionEnd);
		}, duration + 33)
	  );
	},

	stop: function ($el, callCallback) {
	  if ($el && $el.length) {
		clearTimeout($el.data("timer"));

		if (callCallback) {
		  $el.trigger(transitionEnd);
		}

		$el.off(transitionEnd).css("transition-duration", "");

		$el.parent().removeClass("fancybox-is-scaling");
	  }
	}
  };

  // Default click handler for "fancyboxed" links
  // ============================================

  function _run(e, opts) {
	var items = [],
	  index = 0,
	  $target,
	  value,
	  instance;

	// Avoid opening multiple times
	if (e && e.isDefaultPrevented()) {
	  return;
	}

	e.preventDefault();

	opts = opts || {};

	if (e && e.data) {
	  opts = mergeOpts(e.data.options, opts);
	}

	$target = opts.$target || $(e.currentTarget).trigger("blur");
	instance = $.fancybox.getInstance();

	if (instance && instance.$trigger && instance.$trigger.is($target)) {
	  return;
	}

	if (opts.selector) {
	  items = $(opts.selector);
	} else {
	  // Get all related items and find index for clicked one
	  value = $target.attr("data-fancybox") || "";

	  if (value) {
		items = e.data ? e.data.items : [];
		items = items.length ? items.filter('[data-fancybox="' + value + '"]') : $('[data-fancybox="' + value + '"]');
	  } else {
		items = [$target];
	  }
	}

	index = $(items).index($target);

	// Sometimes current item can not be found
	if (index < 0) {
	  index = 0;
	}

	instance = $.fancybox.open(items, opts, index);

	// Save last active element
	instance.$trigger = $target;
  }

  // Create a jQuery plugin
  // ======================

  $.fn.fancybox = function (options) {
	var selector;

	options = options || {};
	selector = options.selector || false;

	if (selector) {
	  // Use body element instead of document so it executes first
	  $("body")
		.off("click.fb-start", selector)
		.on("click.fb-start", selector, {
		  options: options
		}, _run);
	} else {
	  this.off("click.fb-start").on(
		"click.fb-start", {
		  items: this,
		  options: options
		},
		_run
	  );
	}

	return this;
  };

  // Self initializing plugin for all elements having `data-fancybox` attribute
  // ==========================================================================

  $D.on("click.fb-start", "[data-fancybox]", _run);

  // Enable "trigger elements"
  // =========================

  $D.on("click.fb-start", "[data-fancybox-trigger]", function (e) {
	$('[data-fancybox="' + $(this).attr("data-fancybox-trigger") + '"]')
	  .eq($(this).attr("data-fancybox-index") || 0)
	  .trigger("click.fb-start", {
		$trigger: $(this)
	  });
  });

  // Track focus event for better accessibility styling
  // ==================================================
  (function () {
	var buttonStr = ".fancybox-button",
	  focusStr = "fancybox-focus",
	  $pressed = null;

	$D.on("mousedown mouseup focus blur", buttonStr, function (e) {
	  switch (e.type) {
		case "mousedown":
		  $pressed = $(this);
		  break;
		case "mouseup":
		  $pressed = null;
		  break;
		case "focusin":
		  $(buttonStr).removeClass(focusStr);

		  if (!$(this).is($pressed) && !$(this).is("[disabled]")) {
			$(this).addClass(focusStr);
		  }
		  break;
		case "focusout":
		  $(buttonStr).removeClass(focusStr);
		  break;
	  }
	});
  })();
})(window, document, jQuery);